import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';

@Component({
    selector: 'automation-processes',
    templateUrl: './automation-processes.component.html',
    styleUrls: ['./automation-proccesses.component.css']
})
export class AutomationProcessesComponent implements OnInit {

    public allAutomationProcesses: any[] = [];

    public shownProccesses: any[] = [];

    public owners: string[] = [];

    public email: string = '';

    public userStory: string = '';

    constructor(private automationService: AutomationService) { }

    public ngOnInit() {

        this.listAutomationProccess();
    }

    public rollBack(processId: string) {

        this.automationService.removeAutomationProccess(processId)
            .subscribe((data) => {
                this.listAutomationProccess();
            });
    }

    listAutomationProccess() {

        this.automationService.registerSpinner.next(true);

        this.automationService.listAutomationProcesses()
            .subscribe((automationProcesses) => {

                this.allAutomationProcesses = automationProcesses;

                this.shownProccesses = this.allAutomationProcesses;

                this.getOwners();

                this.automationService.registerSpinner.next(false);
            }, () => {
                this.automationService.registerSpinner.next(false);
            });
    }

    private getOwners() {

        this.owners = this.allAutomationProcesses.map((proccess) => proccess.createdBy);
    }

    public changeEmail(email) {

        email = email.toLowerCase().trim();

        this.email = email;

        if (email) {

            this.shownProccesses = this.allAutomationProcesses.filter((proccess) => proccess.createdBy.toLowerCase().indexOf(email) >= 0);
        } else {

            this.shownProccesses = this.allAutomationProcesses;

            if (this.userStory) {

                this.filterByStory(this.userStory);
            } else {

                this.shownProccesses = this.allAutomationProcesses;
            }
        }
    }

    public filterByStory(userStory) {

        userStory = userStory ? userStory.toLowerCase().trim() : '';

        this.userStory = userStory;

        if (userStory) {

            this.shownProccesses = this.allAutomationProcesses.filter((proccess) => proccess.userStories.findIndex((story) => story.toLowerCase().indexOf(userStory) >= 0) >= 0);
        } else {

            if (this.email) {

                this.changeEmail(this.email);
            } else {

                this.shownProccesses = this.allAutomationProcesses;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/automation-proccesses/automation-proccesses.component.ts